module.exports = __webpack_public_path__ + "static/img/10.0d54e8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/10.png
// module id = pys+
// module chunks = 0